import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContextDefinition';
import type { LanguageContextValue } from '../contexts/LanguageContextDefinition';

/**
 * 使用语言上下文的 Hook
 * 
 * @returns 语言上下文值，包含 language、setLanguage 和 t 函数
 * @throws 如果在 LanguageProvider 外部使用则抛出错误
 */
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  
  return context;
}
